import { type JSX, useEffect } from "react";

import { retiredGiveawayTarget } from "../lib/retired-giveaway";

/** Enter the guide through a document load after the client mounts. */
export function LpRedirectRoute(): JSX.Element | null {
  useEffect(() => {
    window.location.replace(retiredGiveawayTarget(window.location.search, window.location.hash));
  }, []);
  return null;
}
